import { ResultFeedbackType } from '@libs/types';
import { toast } from 'react-toastify';
import {
  CircleCheckedIcon,
  CircleErrorIcon,
  CirclePendingIcon,
} from 'src/assets';
import {
  CloseButtonComponent,
  ToastView,
  ToastViewProps,
} from 'src/components';
import { useTheme } from 'styled-components';

export const useShowToast = () => {
  const { colors } = useTheme();

  const showToast = (props: Omit<ToastViewProps, 'icon'>) => {
    if (props.type === ResultFeedbackType.ERROR) {
      toast(<ToastView {...props} icon={<CircleErrorIcon />} />, {
        closeButton: CloseButtonComponent,
        style: { backgroundColor: colors.text.critical },
      });
    } else if (props.type === ResultFeedbackType.PENDING) {
      toast(<ToastView {...props} icon={<CirclePendingIcon />} />, {
        closeButton: CloseButtonComponent,
        style: { backgroundColor: colors.text.pending },
      });
    } else {
      toast(<ToastView {...props} icon={<CircleCheckedIcon />} />, {
        closeButton: CloseButtonComponent,
        style: { backgroundColor: colors.text.success },
      });
    }
  };

  return { showToast };
};
